import React from 'react';

export function detectPlatform(input = '') {
  if (!input) return 'generic';
  let text = '';
  if (typeof input === 'object') {
    text = `${input.platform || ''} ${input.category || ''} ${input.name || ''}`;
  } else {
    text = String(input);
  }
  const t = text.toLowerCase();

  if (t.includes('whatsapp') || t.includes('wa ') || t.includes('wa/')) return 'whatsapp';
  if (t.includes('instagram') || t.includes('insta') || t.includes(' ig ') || t.startsWith('ig ')) return 'instagram';
  if (t.includes('tiktok') || t.includes('tik tok')) return 'tiktok';
  if (t.includes('youtube') || t.includes('yt ') || t.includes('shorts')) return 'youtube';
  if (t.includes('facebook') || t.includes('fb ') || t.includes('fb-') || t.includes('fb/')) return 'facebook';
  if (t.includes('telegram') || t.includes('tg ') || t.includes('tg/')) return 'telegram';
  if (t.includes('twitter') || t.includes(' x ') || t.startsWith('x ') || t.includes('tweet') || t.includes('x.com')) return 'twitter';
  if (t.includes('spotify')) return 'spotify';
  if (t.includes('snapchat') || t.includes('snap ')) return 'snapchat';
  if (t.includes('linkedin')) return 'linkedin';
  if (t.includes('discord')) return 'discord';
  if (t.includes('google') || t.includes('gmail')) return 'google';
  if (t.includes('netflix')) return 'netflix';
  if (t.includes('amazon')) return 'amazon';
  if (t.includes('apple')) return 'apple';
  if (t.includes('openai') || t.includes('chatgpt')) return 'openai';
  if (t.includes('microsoft') || t.includes('outlook') || t.includes('hotmail')) return 'microsoft';
  if (t.includes('yahoo')) return 'yahoo';
  if (t.includes('uber')) return 'uber';
  if (t.includes('paypal')) return 'paypal';
  if (t.includes('binance')) return 'binance';
  if (t.includes('steam')) return 'steam';
  if (t.includes('viber')) return 'viber';
  if (t.includes('line')) return 'line';
  if (t.includes('wechat')) return 'wechat';
  if (t.includes('tinder')) return 'tinder';
  if (t.includes('vk') || t.includes('vkontakte')) return 'vk';
  if (t.includes('threads')) return 'threads';
  if (t.includes('reddit')) return 'reddit';
  if (t.includes('twitch')) return 'twitch';
  if (t.includes('website') || t.includes('traffic') || t.includes('seo')) return 'website';

  return 'generic';
}

function getInitials(name = '') {
  if (!name) return '#';
  const clean = String(name).replace(/[^a-zA-Z0-9]/g, ' ').trim();
  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return '#';
}

export default function PlatformIcon({ platform = '', size = 44, iconSize = 22, style = {}, className = '' }) {
  const p = detectPlatform(platform);
  const radius = Math.round(size * 0.28);

  const baseStyle = {
    width: size,
    height: size,
    borderRadius: radius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...style,
  };

  if (p === 'instagram') {
    return (
      <div
        className={className}
        style={{
          ...baseStyle,
          background: 'linear-gradient(45deg, #F58529 0%, #FEDA77 15%, #DD2A7B 50%, #8134AF 80%, #515BD4 100%)',
          color: '#ffffff',
        }}
      >
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
        </svg>
      </div>
    );
  }

  if (p === 'tiktok') {
    return (
      <div
        className={className}
        style={{
          ...baseStyle,
          background: '#0F172A',
          color: '#FFFFFF',
          position: 'relative',
        }}
      >
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.29 0 .58.04.86.11V9.4a6.33 6.33 0 0 0-.86-.06 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.75a8.28 8.28 0 0 0 4.84 1.55V6.86a4.84 4.84 0 0 1-1.07-.17z" />
        </svg>
      </div>
    );
  }

  if (p === 'youtube') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#FF0000', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      </div>
    );
  }

  if (p === 'facebook') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#1877F2', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      </div>
    );
  }

  if (p === 'whatsapp') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#25D366', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.031 0C5.396 0 .029 5.367.029 11.987c0 2.108.549 4.168 1.595 5.97L.005 24l6.19-1.622a11.94 11.94 0 0 0 5.836 1.509h.005c6.632 0 12-5.367 12-11.987C24.036 5.368 18.665 0 12.031 0zm-.005 21.903a9.96 9.96 0 0 1-5.076-1.39l-.364-.216-3.771.989 1.006-3.676-.237-.377a9.914 9.914 0 0 1-1.52-5.246c0-5.502 4.48-9.982 9.987-9.982 2.666 0 5.172 1.038 7.058 2.925a9.928 9.928 0 0 1 2.921 7.062c-.005 5.503-4.485 9.986-9.994 9.986zm5.474-7.481c-.3-.15-1.776-.876-2.052-.976-.275-.101-.476-.15-.676.15s-.777.976-.952 1.176-.351.226-.652.075a8.215 8.215 0 0 1-2.417-1.493 9.07 9.07 0 0 1-1.674-2.083c-.176-.301-.019-.464.132-.614.135-.135.301-.351.451-.527.151-.176.201-.301.301-.502.101-.201.05-.376-.025-.526-.075-.151-.676-1.63-.927-2.232-.244-.587-.492-.507-.676-.516l-.577-.01c-.2 0-.526.075-.802.376-.275.301-1.052 1.028-1.052 2.508 0 1.48 1.077 2.91 1.228 3.111.15.201 2.119 3.235 5.134 4.538.718.31 1.278.496 1.716.635.72.229 1.376.197 1.895.119.578-.087 1.776-.726 2.027-1.428.25-.702.25-1.304.175-1.428-.075-.126-.275-.201-.576-.351z" />
        </svg>
      </div>
    );
  }

  if (p === 'telegram') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#229ED9', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
        </svg>
      </div>
    );
  }

  if (p === 'twitter') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#0F172A', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      </div>
    );
  }

  if (p === 'spotify') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#1DB954', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.508 17.308c-.217.356-.677.469-1.033.252-2.827-1.728-6.386-2.119-10.579-1.163-.408.093-.816-.161-.909-.569-.093-.408.161-.816.569-.909 4.593-1.049 8.528-.609 11.699 1.332.356.217.469.677.252 1.033zm1.47-3.261c-.273.444-.855.584-1.299.311-3.237-1.99-8.171-2.565-11.999-1.403-.5.152-1.033-.131-1.185-.631-.152-.5.131-1.033.631-1.185 4.382-1.33 9.816-.689 13.542 1.609.444.273.584.855.311 1.299zm.126-3.398C15.228 8.359 8.825 8.147 5.14 9.266c-.596.181-1.229-.158-1.41-.754-.181-.596.158-1.229.754-1.41 4.237-1.286 11.31-1.037 15.782 1.619.537.319.713 1.018.394 1.555-.319.537-1.018.713-1.555.394z" />
        </svg>
      </div>
    );
  }

  if (p === 'google') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#4285F4', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
        </svg>
      </div>
    );
  }

  if (p === 'netflix') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#E50914', color: '#FFFFFF', fontWeight: 900, fontSize: Math.round(size * 0.45), fontFamily: 'sans-serif' }}>
        N
      </div>
    );
  }

  if (p === 'amazon') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#FF9900', color: '#111827', fontWeight: 900, fontSize: Math.round(size * 0.42), fontFamily: 'sans-serif' }}>
        a
      </div>
    );
  }

  if (p === 'apple') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#111827', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.62-.75 1.04-1.8 0.92-2.85-.9.04-1.99.6-2.61 1.34-.55.63-.99 1.68-.86 2.7.99.08 2.02-.51 2.55-1.19z" />
        </svg>
      </div>
    );
  }

  if (p === 'openai') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#10A37F', color: '#FFFFFF', fontWeight: 900, fontSize: Math.round(size * 0.36), fontFamily: 'sans-serif' }}>
        AI
      </div>
    );
  }

  // Clean, professional, solid initial avatar badge for all other services (NO lightning bolt!)
  const initials = getInitials(typeof platform === 'object' ? (platform.name || platform.code || '') : platform);

  return (
    <div
      className={className}
      style={{
        ...baseStyle,
        background: 'var(--accent, #1e40af)',
        color: '#FFFFFF',
        fontWeight: 800,
        fontSize: Math.round(size * 0.36),
        fontFamily: 'ui-monospace, SFMono-Regular, "Plus Jakarta Sans", sans-serif',
        letterSpacing: '0.5px',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        boxShadow: '0 2px 8px rgba(30, 64, 175, 0.25)',
      }}
    >
      {initials}
    </div>
  );
}
